<template>
    <div v-if="!hide"  class="form-network form-network-threads">
        <details v-if="draftInstance.form.urlsTextContentHistory.length" open>
            <summary>
                {{ $t('dash.post-creator.form.link-preview') }}
                <i class="fa-solid fa-caret-down"></i>
            </summary>
            <div class="content-detail form-link">
                <p v-if="draftInstance.form.urlsTextContent.length" class="previewLinkDisabled">
                    <i class="fa-regular fa-circle-exclamation"></i>
                    {{ $t('dash.post-creator.form.threads.link-in-content') }}
                </p>
                <div class="list-thubmmail" :class="{disabled : draftInstance.form.urlsTextContent.length}">
                    <div class="thubmmail" v-for="(url) in draftInstance.form.urlsTextContentHistory" @click="()=>selectUrl(url.value)" :key="url.value">
                        <Checkbox 
                            :id="url.value" 
                            :prefixId="'thubmmail-'" 
                            :isChecked="(draftInstance.form.networks.threads.snippet.link == url.value && !draftInstance.form.urlsTextContent.length)" 
                            :isDisable="(draftInstance.form.networks.threads.snippet.link == url.value || draftInstance.form.urlsTextContent.length)"
                            :add="selectUrl" :remove="()=>{}">
                        </Checkbox>
                        <SnippetNetwork 
                            :link="url.value"
                            :imageUrlDefault="!inputModel.switchCustomSnippet || inputModel.titleSnippet || inputModel.descriptionSnippet ? undefined : inputModel.urlImageSnippet" 
                            :titleDefault="inputModel.switchCustomSnippet ? inputModel.titleSnippet : undefined" 
                            :descriptionDefault="inputModel.switchCustomSnippet ? inputModel.descriptionSnippet : undefined">
                        </SnippetNetwork>
                    </div>
                </div>
            </div>
        </details>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import store from '@/store/index.js';
    import ComponentSwitch from '@/components/dash/utils/switch.vue'
    import SnippetNetwork from './../SnippetNetwork.vue'
    import minxinBot from '@/components/mixins/Bots.vue'
    import minxinPost from '@/components/mixins/Posts.vue'
    import Checkbox from '@/components/dash/utils/checkbox.vue'
    import { VueDraft } from '@mashupweb/draft-lib';
    export default {

        components: {
            ComponentSwitch,
            SnippetNetwork,
            Checkbox
        },
        mixins: [minxinBot,minxinPost],

        props: {
            hide : {
                type: Boolean,
                default: false
            },
            draftInstance: VueDraft

           
        },
        
        data() {
            return {
                inputModel:{
                    switchCustomSnippet: false,
                },

          
    
                lastModeSelected : undefined
            }
        },

        created () {

        },
        methods: {
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },

            selectUrl(url) {
        
                if (!this.draftInstance.form.networks.threads.snippet) this.draftInstance.form.networks.threads.snippet = {}
                this.draftInstance.form.networks.threads.snippet.link = this.draftInstance.form.networks.threads.snippet.link == url ? '' : url
            },


            verifUrlSelected() {
                if (this.draftInstance.form.urlsTextContentHistory.length) {
                    let linkSelect = this.draftInstance.form.networks.threads?.snippet?.link ?? null
                    if (linkSelect && !this.draftInstance.form.urlsTextContentHistory.includes(linkSelect)) {
                        this.selectUrl('')
                    }
                }else{
                    this.selectUrl('')
                }
             
            },

          
        },


       

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
        },

        watch: {
            'draftInstance.form.urlsTextContentHistory.items'(newValue) {
                this.verifUrlSelected()
            },

        },


        beforeDestroy () {
        
        }
        
    }
</script>